import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { Observable, lastValueFrom } from 'rxjs';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { CommonService } from 'src/app/services/common.service';
import { AuthService } from 'src/app/services/auth.service';
import { defer } from 'rxjs';
import * as global from '../../../app/includes/global';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css'],
})
export class AdminDashboardComponent implements OnInit {
  activatedRoute: string = 'dictations'
  filteredCompanies: Observable<string[]>;
  companyControl = new FormControl();
  companies: any = [];
  company_id: any;
  selectedCompany = '';
  currentCompany: any;
  currentUser: any;
  searchCompanyText: any;
  selectedRadio: any = 'notes';
  isWoundCompany: boolean = false; 
  global = global;
  should_show_consent_form: boolean = false;
  constructor( 
    private _router: Router,
    private _route: ActivatedRoute,
    private companyService: CompanyService,
    private _commonService: CommonService,
    private _authService: AuthService,
    private toastr: ToastrService,
    private _companyService: CompanyService
  ) {
    this.activatedRoute = this._route.snapshot.firstChild.routeConfig.path;
    this.currentUser = this._authService.currentUser;
    this.company_id = this._route.parent.snapshot.params.id;
    // this._route.queryParams.subscribe(params => {
    //   this.selectedRadio = params.selectedRadio;
    //   this._router.navigate([`/company/${this.company_id}/dashboard/${this.selectedRadio}`]);
    // });
    // return;
  }

  async ngOnInit() {
    // this._route.parent.paramMap.subscribe(async (params:ParamMap) => {
    //   console.log(params.get('id'));
    //   console.log(typeof params.get('id'));
    //   this.company_id = parseInt(params.get('id'));

    // });
    if(window.location.pathname.includes('patient-charge')) {
      this.activatedRoute = 'admin-charges';
      this.selectedRadio = 'admin-charges';
    }
    await this.getCompany();
    
    if (this.currentUser.product_owner) {
      this.getCompanies();
    }
    // this.companyService.getCompanyName(this.company_id).subscribe((response: any) => {
    //   // console.log("selected", response);
    //   if (response.status == 200) {
    //     if (response.data.company_type.toLowerCase() === 'wound') {
    //       this.isWoundCompany = true;
    //     }
    //     this.selectedCompany = response.data.name;
    //   }
    // })
    this.filteredCompanies = this.companyControl.valueChanges.pipe(
      startWith(''),
      map((value:any) => this.filterCompany(value)));
  }
  private filterCompany(value: string): string[] {
    if (value) {
      const filterValue = value.toLowerCase();
      return this.sortNameVise(this.companies.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0));
    }
    else {
      return this.sortNameVise(this.companies);
    }
  }
  async getCompany() {
    const filter = {
      _id: this.company_id
    };
    const project = {
      name: 1,
      permissions: 1,
      company_type: 1
    };
    const populate = {
      permissions: "key value"
    };
    const response: any = await lastValueFrom(this._companyService.getCompany(filter, project, populate));
    if (response.data.company_type.toLowerCase() === 'wound') {
      this.isWoundCompany = true;
    }
    this.selectedCompany = response.data.name;
    if (response.data.permissions.length > 0) {
      [this.should_show_consent_form] = this._companyService.validateCompanyPermission(response.data.permissions, ["should_show_consent_form"]);
    }
  }

  sortNameVise(arrayTosort){
      let users=arrayTosort;
      let result=users.sort(function(a, b){
          if(a.name?.toLowerCase() < b.name?.toLowerCase()) { return -1; }
          if(a.name?.toLowerCase() > b.name?.toLowerCase()) { return 1; }
          return 0;
      })
      return result;
  }


  changeRoute() {
    this.selectedRadio = this.activatedRoute;
    this._router.navigate([`${this.activatedRoute}`], { relativeTo: this._route })
  }

  async getCompanies() {
    const response: any = await this.companyService.getAllCompanies().toPromise();
    // console.log("init companies");
    if (response.status == 200) {
      this.companies = response.data;
      this.companies=this.sortNameVise(this.companies);
      // console.log("companies",this.companies);
      this.currentCompany = this._route.parent.snapshot.params.id;
      const presentCompany = this.companies.find(company => this.company_id === company._id);
      if (presentCompany && presentCompany?.company_type.toLowerCase() === 'wound') {
        this.isWoundCompany = true;
      }
      const index = this.companies.findIndex(company => this.currentCompany === company._id);
      this.currentCompany = this.companies[index]._id;
      // this.companies.splice(index,1);
      // console.log("curre",this.currentCompany);
      // this.companyControl.setValue(this.currentCompany.name);     
    }
    else if (response.status == 403) {
      this.toastr.error(response.message, "ERROR");
    }
  }
  navigate($event, id) {
    if ($event.isUserInput) {
      // console.log("id", id);
      this.currentCompany = id;
      // console.log({id});
      // this._router.navigateByUrl(`/company/${id}/dashboard/notes`); 
      if (this.currentCompany !== this._route.parent.snapshot.params.id) {
        this._router.navigateByUrl(`/dashboard`, { skipLocationChange: true }).then(() =>
          // this._router.navigate([`/company/${this.currentCompany}/dashboard`])
          this._router.navigate([`/company/${this.currentCompany}/dashboard/${this.activatedRoute}`], { relativeTo: this._route })
        );
      }
    }

  }

}
